import { Injectable, Injector } from '@angular/core';
import { WelcomeBackComponent } from '../../components/authentication/welcome-back/welcome-back.component';
import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';

@Injectable({
  providedIn: 'root'
})
export class WelcomeBackService {

  constructor(private overlay: Overlay, private injector: Injector) { }
  
  openWelcomeBackModal(){
    setTimeout(() => {
      const overlayRef = this.overlay.create({
        hasBackdrop: true,
        backdropClass: 'cdk-overlay-dark-backdrop',
        positionStrategy: this.overlay.position()
          .global()
          .centerHorizontally()
          .centerVertically()
      });

      const portal = new ComponentPortal(WelcomeBackComponent, null, this.injector);
      const modal = overlayRef.attach(portal).instance;

      modal.close = () => overlayRef.dispose();
    }, 100);
      
  }



}


